// extracted by mini-css-extract-plugin
module.exports = {"menu":"SubHeader_menu__OEMBq","active":"SubHeader_active__KPGOK","solucoes":"SubHeader_solucoes__vBAV3","boost":"SubHeader_boost__A2oIZ"};